import type { CheckoutPreference } from '@/scopes/checkout/domain/types'

import { PreferencesDataClient, PreferencesFormData } from '@/scopes/checkout/domain/types/checkoutPreferences'
import { Logger } from '@/scopes/common/domain/types'
import { produce } from 'immer'

interface PreferenceUpdatePayload {
  checked: boolean
  value?: string | null
}

export function updatePreferenceSelection(payload: PreferenceUpdatePayload) {
  return produce((preference: CheckoutPreference) => {
    preference.selected = payload.checked
    preference.value = payload.value ?? preference.value
  })
}

interface PreferenceActionsDependencies {
  client: PreferencesDataClient
  logger: Logger
}

interface PreferenceDataSubmittedPayload {
  sid: string
  preferencesData: PreferencesFormData | null
}

export function preferencesDataActions(
  {
    client,
    logger,
  }:
  PreferenceActionsDependencies,
) {
  async function preferencesDataSubmitted({
    sid,
    preferencesData,
  }: PreferenceDataSubmittedPayload) {
    if (!preferencesData) {
      return
    }
    try {
      await client.submitPreferencesData(sid, preferencesData)
    }
    catch (error) {
      logger.logError(error as Error, { action: 'preferencesSubmitted', sid })
    }
  }

  return {
    preferencesDataSubmitted,
  }
}
